const FilledTrashcanIcon = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1229 3.00752C13.4103 3.00752 13.6496 3.24618 13.6496 3.54986V3.83064C13.6496 4.12693 13.4103 4.37297 13.1229 4.37297H0.877068C0.588906 4.37297 0.349609 4.12693 0.349609 3.83064V3.54986C0.349609 3.24618 0.588906 3.00752 0.877068 3.00752H3.03146C3.46909 3.00752 3.84995 2.69645 3.9484 2.25756L4.06122 1.75364C4.23656 1.06722 4.8136 0.611328 5.474 0.611328H8.52522C9.17843 0.611328 9.76194 1.06722 9.93081 1.71743L10.0515 2.25682C10.1493 2.69645 10.5301 3.00752 10.9685 3.00752H13.1229ZM12.0284 13.2715C12.2533 11.1753 12.6471 6.1952 12.6471 6.14496C12.6615 5.99275 12.6119 5.84867 12.5134 5.73266C12.4078 5.62405 12.2741 5.55977 12.1268 5.55977H1.87802C1.72998 5.55977 1.58914 5.62405 1.49141 5.73266C1.39224 5.84867 1.34337 5.99275 1.35056 6.14496C1.35188 6.15419 1.36601 6.32961 1.38963 6.62289C1.49458 7.92573 1.78687 11.5544 1.97575 13.2715C2.10941 14.5364 2.9394 15.3315 4.14163 15.3603C5.06936 15.3817 6.0251 15.3891 7.00241 15.3891C7.92295 15.3891 8.85786 15.3817 9.81433 15.3603C11.0582 15.3389 11.8875 14.5579 12.0284 13.2715Z"
        fill="#599393"
      />
    </svg>
  );
};
export default FilledTrashcanIcon;
